import { RootState } from "@app/redux/root-reducer";

export const selectAddWishlistProducts = (store: RootState) =>
  store.wishlistReducer.addWishlist;
export const selectGetWishlistProducts = (store: RootState) =>
  store.wishlistReducer.getWishlist;
export const selectDeleteWishlistProducts = (store: RootState) =>
  store.wishlistReducer.deleteWishlist;
